import React, {useEffect, useState} from "react";
import {Collapse} from "react-bootstrap";
import ProductDescriptorsAPI from "../modules/ProductDescriptorsAPI";
import PropTypes from "prop-types";
import RatingsOverview from "./RatingsOverview";
import Reviews from "./Reviews";

const RatingsAndReviews = (props) => {
  const {
    location = {"hash": null},
    productDescriptorId,
    "ratings": {
      "average": averageRatingGeneral,
      count
    } = {
      "average": 0,
      "count": 0
    }
  } = props;

  const [
    open,
    setOpen
  ] = useState(false);

  const [
    ratingByType,
    setRatingByType
  ] = useState({
    "averageRatingPrice": 0,
    "averageRatingQuality": 0,
    "averageRatingStyle": 0
  });

  const [
    ratingByScore,
    setRatingByScore
  ] = useState({
    /* eslint-disable sort-keys */
    "oneStar": 0,
    "twoStars": 0,
    "threeStars": 0,
    "fourStars": 0,
    "fiveStars": 0
    /* eslint-enable sort-keys */
  });

  const fetchRatingsAndReviews = () => {
    ProductDescriptorsAPI.fetchRatings(productDescriptorId).
      then((response) => {
        const {
          "data": {
            "ratings": {
              "average_rating_by_type": {
                "price": averageRatingPrice = 0,
                "quality": averageRatingQuality = 0,
                "style": averageRatingStyle = 0
              } = {},
              "feedback_general_by_score": {
                "one": oneStar = 0,
                "two": twoStars = 0,
                "three": threeStars = 0,
                "four": fourStars = 0,
                "five": fiveStars = 0
              } = {}
            }
          }
        } = response;
        setRatingByScore({
          /* eslint-disable sort-keys */
          oneStar,
          twoStars,
          threeStars,
          fourStars,
          fiveStars
          /* eslint-enable sort-keys */
        });
        setRatingByType({
          averageRatingPrice,
          averageRatingQuality,
          averageRatingStyle
        });
      });
  };

  const {
    oneStar,
    twoStars,
    threeStars,
    fourStars,
    fiveStars
  } = ratingByScore;

  const {
    averageRatingPrice,
    averageRatingQuality,
    averageRatingStyle
  } = ratingByType;

  const toggleRatingsAndReviewsDisplay = () => {
    setOpen(!open);
  };

  const scrollToRatingsAndReviews = () => {
    const target = location.hash || null;
    const element = document.querySelector(target);

    if (element) {
      setOpen(true);
      element.scrollIntoView();
    }
  };

  useEffect(() => {
    fetchRatingsAndReviews();
    scrollToRatingsAndReviews();
  }, [productDescriptorId]);

  return (
    <div id="ratings-and-reviews-container">
      <div className="pv8">
        <h2 className="styled_h5">
          Ratings & Reviews
        </h2>
        <span
          className={open ? "collapse-btn" : "expand-btn"}
          onClick={toggleRatingsAndReviewsDisplay} // eslint-disable-line react/jsx-no-bind
          title="toggle-reviews"
        />
      </div>
      <Collapse in={open}>
        <div id="ratings-and-reviews">
          <RatingsOverview
            averageRatingGeneral={averageRatingGeneral}
            averageRatingPrice={averageRatingPrice}
            averageRatingQuality={averageRatingQuality}
            averageRatingStyle={averageRatingStyle}
            count={count}
            /* eslint-disable react/jsx-sort-props */
            oneStar={oneStar}
            twoStars={twoStars}
            threeStars={threeStars}
            fourStars={fourStars}
            fiveStars={fiveStars}
            /* eslint-enable react/jsx-sort-props */
          />
          <Reviews
            productDescriptorId={productDescriptorId}
          />
        </div>
      </Collapse>
    </div>
  );
};

RatingsAndReviews.defaultProps = {"location": {"hash": null}};

RatingsAndReviews.propTypes = {
  "location": PropTypes.object,
  "productDescriptorId": PropTypes.number.isRequired,
  "ratings": PropTypes.shape({
    "average": PropTypes.number,
    "count": PropTypes.number
  }).isRequired
};

export default RatingsAndReviews;
